import React from "react";
import "./hierarchy.css";

export default function JumuiaModal({ jumuia, onClose }) {
  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          <h3>Jumuiya Details</h3>
          <button className="close" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="modal-body">
          <p>
            <strong>Name:</strong> {jumuia.name}
          </p>
          <p>
            <strong>Leader:</strong> {jumuia.leader_name || "—"}
          </p>
          <p>
            <strong>Status:</strong> {jumuia.status}
          </p>
          <p>
            <strong>Created At:</strong>{" "}
            {new Date(jumuia.created_at).toLocaleDateString()}
          </p>
        </div>

        <div className="modal-actions">
          <button className="btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
